<emm-management-layout>
    <emm-progress-bar [isLoading$]="anyLoading$"></emm-progress-bar>
    <emm-search-filter
        [addDialog]="true"
        [attr.data-testid]="'location_set_type_select'"
        [displaySearchWithOptions]="false"
        [fields]="fields$ | async"
        [isAdminOrAuthor]="this.isAdmin || this.isAuthor"
        [isSuperAdmin]="this.isSuperAdmin"
        layout-center-header
        (add)="openCreateLocationSetDialog()"
        (filter)="onFilter($event)"
    ></emm-search-filter>
    <emm-generic-items-tree *ngIf="nodes$ | async"
        [contextMenuActions]="locationSetsContextMenuActions$ | async"
        [disableContextActions]="centerLoading$ | async"
        [disableDefaultOnMove]="true"
        [items]="nodes$ | async"
        layout-center-content
        [options]="options"
        [readonly]="isReadOnly$ | async"
    ></emm-generic-items-tree>
    <emm-management-attributes-header
        *ngIf="locationSetDetail$ | async as item"
        layout-right-header
        [name]="item.name"
        [tag]="item.tag"
    ></emm-management-attributes-header>
    <emm-location-sets-form
        #form
        layout-right-content
        [isSuperAdmin]="isSuperAdmin"
        [isAdmin]="isAdmin"
    ></emm-location-sets-form>
    <emm-management-attributes-footer
        *ngIf="locationSetDetail$ | async as item"
        [disableCancel]="!locationSetsForm || !locationSetsForm.isFormReady()"
        [disableUpdate]="!locationSetsForm || !locationSetsForm.hasChanges()"
        layout-right-footer
        (cancel)="locationSetsForm.cancel()"
        (submit)="locationSetsForm.submit(item.tag)"
        class="fixed-row-bottom"
    ></emm-management-attributes-footer>
</emm-management-layout>
